import React, { Component } from 'react';
import {getUrlVars,getiOS} from './helper/format';

export default class LoginCheck extends Component {
    constructor(props)
    {
      super(props);
      this.data = getUrlVars();

      console.log(this.data);
        var keyHash = this.data.k ? this.data.k : "";
        var logo = this.data.l ? this.data.l : "";
      if( this.data.site === "mipl09" ) {
        keyHash = 'dHYraFJOMFZzS24vblNvUXdKMUtZL2lleUtUOUlMSXZaZmZhVjRPSFIrUT0='
      }

      if ( logo != '' ) {
          sessionStorage.setItem('logo', logo);
      }

      if( keyHash === "" ) {
        window.location.href = '/Login';
        //sessionStorage.setItem('loginKey', parsedData.data.uk);
      } else {
        sessionStorage.setItem('loginKey', keyHash);
        window.location.href = '/Option';
      }
    }
    render()
    {
        return(
            <div></div>
        )
    }
}
